import { PluginSpecification } from '@valtimo/plugin';
import { DestructionProcedureConfigurationComponent } from './components/destructionprocedure-configuration/destructionprocedure-configuration.component';
import { TEZZA_PLUGIN_LOGO_BASE64 } from './assets/tezza-plugin-logo';

const destructionProcedurePluginSpecification: PluginSpecification = {
  pluginId: 'destructionprocedureplugin',
  pluginConfigurationComponent: DestructionProcedureConfigurationComponent,
  pluginLogoBase64: TEZZA_PLUGIN_LOGO_BASE64,
  pluginTranslations: {
    nl: {
      title: 'Destruction Procedure Proces',
      description:
        'De Destruction Procedure-plugin beheerd de configuratie voor het Destruction Procedure proces',
      configurationTitle: 'Configuratienaam',
      configurationTitleTooltip:
        'De naam van de huidige plugin-configuratie. Onder deze naam kan de configuratie in de rest van de applicatie teruggevonden worden.',
      departmentName: 'Afdeling naam',
      departmentNameTooltip: 'Dit veld moet de naam van de afdeling bevatten.',
      departmentHeadUsername: 'Afdelingshoofd gebruikersnaam',
      departmentHeadUsernameTooltip: 'Dit veld moet de gebruikersnaam van het afdelingshoofd bevatten.',
      departments: 'Afdelingen',
      departmentsTooltip: 'Afdelingen binnen het DestructionProcedure proces',
      addDestructionProcedureType: 'Afdeling toevoegen',
      headInformationManagerUsername: 'Hoofd Informatiebeheerder gebruikersnaam',
      headInformationManagerUsernameTooltip: 'Dit veld moet de gebruikersnaam van de hoofd informatie beheerder bevatten.',
      archivalEmail: 'Archief e-mail',
      archivalEmailTooltip: 'Dit veld moet het e-mailadres voor archivering bevatten.',
    },
    en: {
      title: 'Destruction Procedure Process',
      description:
        'The Destruction Procedure plugin manages the configuration for the Destruction Procedure process',
      configurationTitle: 'Configuration name',
      configurationTitleTooltip:
        'The name of the current plugin configuration. Under this name, the configuration can be found throughout the rest of the application.',
      departmentName: 'Department name',
      departmentNameTooltip: 'This field must contain the name of the department.',
      departmentHeadUsername: 'Department head username',
      departmentHeadUsernameTooltip: 'This field must contain the username of the department head.',
      departments: 'Departments',
      departmentsTooltip: 'Departments within the Destruction Procedure process',
      addDestructionProcedureType: 'Add department',
      headInformationManagerUsername: 'Head Information Manager Username',
      headInformationManagerUsernameTooltip: 'This field must contain the username of the head information manager.',
      archivalEmail: 'Archival Email',
      archivalEmailTooltip: 'This field must contain the email address for archival purposes.',
    },
    de: {
      title: 'Destruction Procedure-Prozess',
      description:
        'Das Destruction Procedure-Plugin verwaltet die Konfiguration für den Destruction Procedure-Prozess',
      configurationTitle: 'Konfigurationsname',
      configurationTitleTooltip:
        'Der Name der aktuellen Plugin-Konfiguration. Unter diesem Namen kann die Konfiguration im restlichen Teil der Anwendung wiedergefunden werden.',
      departmentName: 'Name der Abteilung',
      departmentNameTooltip: 'Dieses Feld muss den Namen der Abteilung enthalten.',
      departmentHeadUsername: 'Abteilungsleiter (RSIN)',
      departmentHeadUsernameTooltip: 'Dieses Feld muss die RSIN-Nummer des Abteilungsleiters enthalten.',
      departments: 'Abteilungen',
      departmentsTooltip: 'Abteilungen innerhalb des Destruction Procedure-Prozesses',
      addDestructionProcedureType: 'Abteilung hinzufügen',
      headInformationManagerUsername: 'Hoofd Informatiebeheerder gebruikersnaam',
      headInformationManagerUsernameTooltip: 'Dit veld moet de gebruikersnaam van de informatie beheerder bevatten.',
      archivalEmail: 'Archief e-mail',
      archivalEmailTooltip: 'Dit veld moet het e-mailadres voor archivering bevatten.',
    },
  },
};

export { destructionProcedurePluginSpecification };
